module.exports = {
  materalclass: [
    { value: 1, text: '原燃料类' },
    { value: 2, text: '资材料类' },
    { value: 3, text: '设备备件类' },
    { value: 4, text: '建设工程类' },
    { value: 5, text: '维修工程类' },
    { value: 6, text: '服务类' },
  ],
  picData: {
    status: 1,
    data: {
      result: {
        picUrl: '11',
        modifiedTime: '2022-12-07 10:57:02',
        pageIndex: 0,
        pageSize: 0,
        id: 34,
        picName: '3',
        sort: '1',
        isShow: 0
      }
    },
    msg: '保存修改轮播图信息成功'
  },
  childrenclass: [
    { id: 1, className: '原燃料类' },
    { id: 2, className: '资材料类' },
    { id: 3, className: '设备备件类' },
    { id: 4, className: '建设工程类' },
    { id: 5, className: '维修工程类' },
    { id: 6, className: '服务类' },
  ],
  materaltitleclass: [
    { state: 1, title: '原燃料类', num: 0 },
    { state: 2, title: '资材料类', num: 0 },
    { state: 3, title: '设备备件类', num: 0 },
    { state: 4, title: '建设工程类', num: 0 },
    { state: 5, title: '维修工程类', num: 0 },
    { state: 6, title: '服务类', num: 0 },
  ],
  salestitleclass: [
    { state: 1, title: '软件开发类', num: 0 },
    { state: 2, title: '工程施工类', num: 0 },
    { state: 3, title: '设备供货类', num: 0 },
    { state: 4, title: '系统集成类', num: 0 },
    { state: 5, title: '服务类', num: 0 },
    { state: 6, title: '国际工程承包', num: 0 },
    { state: 7, title: '机电产品', num: 0 },
    { state: 8, title: '化工产品', num: 0 },
  ],
  announcement: [
    { value: 1, text: '鞍钢电力专用型材用钢供货南方电网招募公告', date: '01-20' },
    { value: 2, text: '鞍钢超高强海工钢助力我国可燃冰试采招募公告', date: '01-20' },
    { value: 3, text: '鞍钢股份鲅鱼圈分公司被评为“全国安全文化建设示范企业”供应商招募公告', date: '01-20' },
    { value: 4, text: '鞍钢万能线质保能力通过CRCC现场招募公告', date: '01-20' }
  ],
  salesClassifyList: [
    { value: 1, text: '鞍山钢铁集团有限公司', url: 'static/img/home/suppliers/sales1.png' },
    { value: 2, text: '攀钢集团有限公司', url: 'static/img/home/suppliers/sales1.png' },
    { value: 3, text: '非钢版块', url: 'static/img/home/suppliers/sales1.png' }
  ],
  imgsList: [
    { sort: 0, picName: '鞍山钢铁集团有限公司', picLocalUrl: 'http://test.ansteelscm.com/cpu-supplymgr-fe/static/img/home/c1.jpg', picUrl: 'http://test.ansteelscm.com' },
    { sort: 1, picName: '攀钢集团有限公司', picLocalUrl: 'http://test.ansteelscm.com/cpu-supplymgr-fe/static/img/home/c2.jpg', picUrl: 'http://test.ansteelscm.com' },
    { sort: 2, picName: '非钢版块', picLocalUrl: 'http://test.ansteelscm.com/cpu-supplymgr-fe/static/img/home/c3.jpg', picUrl: 'http://test.ansteelscm.com' }
  ],
  supplierBlackList: [
    { value: 1, text: '宜昌市璜时得粘合剂开发有限公司' },
    { value: 2, text: '沈阳虹桥胶带有限公司' },
    { value: 3, text: '绵阳市精锐数控工具制造有限公司' },
    { value: 4, text: '鞍山辽绵数控工具经销有限公司' },
    { value: 5, text: '鞍山顺翔工矿物资有限公司' },
    { value: 6, text: '鞍山市霖德物资经销有限公司' },
    { value: 6, text: '沈阳瑞倍特机械设备有限公司' },
    { value: 6, text: '沈阳兴岛科学仪器有限公司' },
    { value: 6, text: '鞍山市新钢标样开发有限公司' },
    { value: 6, text: '鞍山沃德化工科技有限公司' },
    { value: 6, text: '江苏天辉环保科技有限公司' },
    { value: 6, text: '河北九骏建筑材料有限公司' },
    { value: 6, text: '鞍山德洪源物资有限公司' },
    { value: 6, text: '鞍山市盛亿昌物资有限公司' }
  ],
  purchaser: [
    { value: 1, text: '这里是主要采购单位1' },
    { value: 2, text: '这里是主要采购单位2' },
    { value: 3, text: '这里是主要采购单位3' },
    { value: 4, text: '这里是主要采购单位4' },
    { value: 5, text: '这里是主要采购单位5' },
    { value: 6, text: '这里是主要采购单位6' }
  ],
  categoryData: [
    { name: '原燃料类',
      id: 1,
      children: [
        { name: '矿石及矿产品',
          id: 7,
          children: [
            {name: '铁矿石', id: 76},
            {name: '铁矿石产品', id: 77},
            {name: '其它矿石', id: 78},
            {name: '其它矿产品', id: 79}
          ]},
        { name: '生铁',
          id: 8,
          children: [
            {name: '非合金生铁', id: 80},
            {name: '合金生铁', id: 81}
          ]},
        { name: '钢坯（锭）',
          id: 9,
          children: [
            {name: '钢坯', id: 82},
            {name: '钢锭', id: 83}
          ]},
        { name: '合金及有色金属',
          id: 10,
          children: [
            {name: '普通合金', id: 84},
            {name: '特种合金', id: 85},
            {name: '其它合金', id: 86},
            {name: '有色金属', id: 87}
          ]},
        { name: '废钢',
          id: 11,
          children: [
            {name: '熔炼用废钢', id: 88},
            {name: '非熔炼用废钢', id: 89}
          ]},
        { name: '烟煤',
          id: 12,
          children: [
            {name: '焦煤', id: 90},
            {name: '1/3焦煤', id: 91},
            {name: '瘦焦煤', id: 92},
            {name: '肥煤', id: 93},
            {name: '气煤', id: 94},
            {name: '瘦煤', id: 95},
            {name: '其它炼焦煤', id: 96},
            {name: '普通烟煤', id: 97}
          ]},
        { name: '无烟煤',
          id: 13,
          children: [
            {name: '无烟煤', id: 98}
          ]},
        { name: '褐煤及煤基燃料',
          id: 14,
          children: [
            {name: '动力煤', id: 99},
            {name: '煤基燃料', id: 100},
            {name: '其它褐煤', id: 101}
          ]},
        { name: '焦炭',
          id: 15,
          children: [
            {name: '焦炭', id: 102}
          ]}
      ]
    },
    { name: '资材料类',
      id: 2,
      children: [
        { name: '耐火材料',
          id: 16,
          children: [
            {name: '耐火原料', id: 103},
            {name: '定型耐火材料', id: 104},
            {name: '不定型耐火材料', id: 105},
            {name: '隔热耐火材料', id: 106},
            {name: '耐火材料添加剂', id: 107}
          ]},
        { name: '冶金辅料',
          id: 17,
          children: [
            {name: '冶金熔剂', id: 108},
            {name: '保温材料', id: 109},
            {name: '其它辅料', id: 110}
          ]},
        { name: '炭素制品',
          id: 18,
          children: [
            {name: '炭素制品', id: 111}
          ]},
        { name: '钢铁表面处理剂',
          id: 19,
          children: [
            {name: '钢铁表面处理剂', id: 112}
          ]},
        { name: '包装材料',
          id: 20,
          children: [
            {name: '金属包装材料', id: 113},
            {name: '塑料包装材料', id: 114},
            {name: '纸质包装材料', id: 115},
            {name: '纤维包装材料', id: 116},
            {name: '草质包装材料', id: 117},
            {name: '木质包装材料', id: 118},
            {name: '其它包装材料', id: 119}
          ]},
        { name: '化工产品',
          id: 21,
          children: [
            {name: '酸碱盐', id: 120},
            {name: '汽柴油', id: 121},
            {name: '工业油脂', id: 122},
            {name: '油品材料', id: 123},
            {name: '油漆涂料', id: 124},
            {name: '选矿药剂', id: 125},
            {name: '水处理药剂', id: 126},
            {name: '化学药品', id: 127},
            {name: '检验检定材料', id: 128},
            {name: '工业气体', id: 129},
            {name: '橡胶制品', id: 130},
            {name: '橡胶杂品', id: 131},
            {name: '塑料制品', id: 132},
            {name: '民爆产品', id: 133},
            {name: '其它化工产品', id: 134}
          ]},
        { name: '专用工具',
          id: 22,
          children: [
            {name: '矿山专用工具', id: 135},
            {name: '冶炼专用工具', id: 136},
            {name: '轧钢专用工具', id: 137},
            {name: '动力专用工具', id: 138},
            {name: '其它专用工具', id: 139}
          ]},
        { name: '通用工具',
          id: 23,
          children: [
            {name: '通用工具', id: 140}
          ]},
        { name: '钢材及制品',
          id: 24,
          children: [
            {name: '板材', id: 141},
            {name: '型材', id: 142},
            {name: '管材', id: 143},
            {name: '线材', id: 144},
            {name: '钢丝绳', id: 145},
            {name: '其它钢材及制品', id: 146}
          ]},
        { name: '金属加工制品',
          id: 25,
          children: [
            {name: '钢球钢段', id: 147},
            {name: '其它金属加工制品', id: 148}
          ]},
        { name: '有色型材',
          id: 26,
          children: [
            {name: '铜材', id: 149},
            {name: '铝材', id: 150},
            {name: '其它有色型材', id: 151}
          ]},
        { name: '建筑材料',
          id: 27,
          children: [
            {name: '砌筑材料', id: 152},
            {name: '装饰材料', id: 153},
            {name: '保温材料', id: 154},
            {name: '防水材料', id: 155},
            {name: '其它建筑材料', id: 156}
          ]},
        { name: '水暖管件',
          id: 28,
          children: [
            {name: '金属水暖管件', id: 157},
            {name: '其它水暖管件', id: 158}
          ]},
        { name: '五金材料',
          id: 29,
          children: [
            {name: '五金材料', id: 159}
          ]},
        { name: '电气材料',
          id: 30,
          children: [
            {name: '照明电器', id: 160},
            {name: '消防电器', id: 161},
            {name: '三类电气', id: 162},
            {name: '其它电气材料', id: 163}
          ]},
        { name: '电缆电线',
          id: 31,
          children: [
            {name: '电力电缆', id: 164},
            {name: '控制电缆', id: 165},
            {name: '橡套电缆', id: 166},
            {name: '信号电缆', id: 167},
            {name: '计算机电缆', id: 168},
            {name: '通信电缆', id: 169},
            {name: '通信光缆', id: 170},
            {name: '船用电缆', id: 171},
            {name: '耐高温电缆', id: 172},
            {name: '特种电缆', id: 173},
            {name: '电线', id: 174},
            {name: '其它电缆电线', id: 175}
          ]},
        { name: '纤维及制品',
          id: 32,
          children: [
            {name: '石棉制品', id: 176},
            {name: '布麻化纤制品', id: 177},
            {name: '纸质制品', id: 178},
            {name: '其它纤维及制品', id: 179}
          ]},
        { name: '木材',
          id: 33,
          children: [
            {name: '原木', id: 180},
            {name: '加工木材', id: 181},
            {name: '其它木材', id: 182}
          ]},
        { name: '草制品',
          id: 34,
          children: [
            {name: '防寒草制品', id: 183},
            {name: '其它草制品', id: 184}
          ]},
        { name: '劳保用品',
          id: 35,
          children: [
            {name: '一般劳保品', id: 185},
            {name: '特种劳保品', id: 186},
            {name: '洗涤防护用品', id: 187}
          ]},
        { name: '办公用品',
          id: 36,
          children: [
            {name: '办公文具', id: 188},
            {name: '办公日用品', id: 189},
            {name: '办公小型设备', id: 190},
            {name: '办公电脑组件', id: 191},
            {name: '办公设备耗材', id: 192},
            {name: '办公家具', id: 193},
            {name: '其它办公用品', id: 194}
          ]},
        { name: '卫生生活',
          id: 37,
          children: [
            {name: '医用药品', id: 195},
            {name: '保健药品', id: 196},
            {name: '医用耗材', id: 197},
            {name: '防疫用品', id: 198},
            {name: '医用辅助器材', id: 199},
            {name: '康复用品', id: 200},
            {name: '纺织品', id: 201},
            {name: '炊具餐具', id: 202},
            {name: '其它卫生生活用品', id: 203}
          ]},
        { name: '宣教文体',
          id: 38,
          children: [
            {name: '宣传用品', id: 204},
            {name: '文教用品', id: 205},
            {name: '体育用品', id: 206},
            {name: '卫生用品', id: 207},
            {name: '其它用品', id: 208}
          ]},
        { name: '食材食品',
          id: 39,
          children: [
            {name: '粮食及产品', id: 209},
            {name: '食油及产品', id: 210},
            {name: '果蔬及产品', id: 211},
            {name: '肉类及产品', id: 212},
            {name: '蛋禽及产品', id: 213},
            {name: '生鲜及产品', id: 214},
            {name: '调料', id: 215},
            {name: '酒品', id: 216},
            {name: '饮料', id: 217},
            {name: '其它食材食品', id: 218}
          ]},
        { name: '畜牧产品',
          id: 40,
          children: [
            {name: '饲料', id: 219},
            {name: '饲料添加剂', id: 220},
            {name: '畜牧药品', id: 221},
            {name: '活体动物', id: 222},
            {name: '其它畜牧产品', id: 223}
          ]},
        { name: '绿化苗木',
          id: 41,
          children: [
            {name: '绿化苗木', id: 224}
          ]},
        { name: '杂品',
          id: 42,
          children: [
            {name: '杂品', id: 225}
          ]}
      ]},
    { name: '设备备件类',
      id: 3,
      children: [
        { name: '工艺',
          id: 43,
          children: [
            {name: '采矿设备', id: 226},
            {name: '选矿设备', id: 227},
            {name: '炼焦设备', id: 228},
            {name: '化工设备', id: 229},
            {name: '烧结设备', id: 230},
            {name: '炼铁设备', id: 231},
            {name: '炼钢设备', id: 232},
            {name: '热轧设备', id: 233},
            {name: '冷轧设备', id: 234},
            {name: '型材设备', id: 235},
            {name: '管材设备', id: 236},
            {name: '钒业设备', id: 237},
            {name: '钛业设备', id: 238},
            {name: '发电设备', id: 239},
            {name: '输配电设备', id: 240},
            {name: '制氧设备', id: 241},
            {name: '燃气设备', id: 242},
            {name: '供水设备', id: 243},
            {name: '钢材加工设备', id: 244},
            {name: '资源综合利用设备', id: 245},
            {name: '其它', id: 246}
          ]},
        { name: '机械',
          id: 44,
          children: [
            {name: '非标机械', id: 247},
            {name: '传动机械', id: 248},
            {name: '建筑机械', id: 249},
            {name: '热能动力', id: 250},
            {name: '制冷采暖', id: 251},
            {name: '加工机床', id: 252},
            {name: '风机', id: 253},
            {name: '气体压缩机', id: 254},
            {name: '水泵', id: 255},
            {name: '阀门', id: 256},
            {name: '液压润滑气动', id: 257},
            {name: '密封件', id: 258},
            {name: '波纹管补偿器', id: 259},
            {name: '剪切', id: 260},
            {name: '喷打抛磨', id: 261},
            {name: '其它', id: 262}
          ]},
        { name: '电气自动化',
          id: 45,
          children: [
            {name: '变压器', id: 263},
            {name: '高压配电', id: 264},
            {name: '低压配电', id: 265},
            {name: '传动控制', id: 266},
            {name: '整流装置', id: 267},
            {name: '电气保护', id: 268},
            {name: '继电保护', id: 269},
            {name: '电机', id: 270},
            {name: '二类电气', id: 271},
            {name: '电子器件', id: 272},
            {name: '铁路电器', id: 273},
            {name: '其它', id: 274}
          ]},
        { name: '仪器仪表',
          id: 46,
          children: [
            {name: '工业自动化仪表', id: 275},
            {name: '电工仪器仪表', id: 276},
            {name: '分析检测仪器', id: 277},
            {name: '衡器', id: 278},
            {name: '特种仪表', id: 279},
            {name: '其它', id: 280}
          ]},
        { name: '信息通信',
          id: 47,
          children: [
            {name: '计算机及网络硬件', id: 281},
            {name: '计算机软件', id: 282},
            {name: '通讯系统', id: 283},
            {name: '监控系统', id: 284},
            {name: '报警系统', id: 285},
            {name: '音视频系统', id: 286},
            {name: '铁路信号装置', id: 287},
            {name: '其它', id: 288}
          ]},
        { name: '安全环保节能',
          id: 48,
          children: [
            {name: '消防设备器材', id: 289},
            {name: '安全防护设备', id: 290},
            {name: '水处理设备', id: 291},
            {name: '通风除尘设备', id: 292},
            {name: '脱硫脱硝装备', id: 293},
            {name: '余热余压利用装备', id: 294},
            {name: '节能设备', id: 295},
            {name: '其它', id: 296}
          ]},
        { name: '运输',
          id: 49,
          children: [
            {name: '铁路机车', id: 297},
            {name: '铁路车辆', id: 298},
            {name: '公路车辆', id: 299},
            {name: '特种车辆', id: 300},
            {name: '工程机械', id: 301},
            {name: '输送机械', id: 302},
            {name: '港口机械', id: 303},
            {name: '其它', id: 304}
          ]},
        { name: '五金机电',
          id: 50,
          children: [
            {name: '电动工具', id: 305},
            {name: '风动工具', id: 306},
            {name: '液压工具', id: 307},
            {name: '紧固件', id: 308},
            {name: '电动电液推杆', id: 309},
            {name: '法兰弯头', id: 310},
            {name: '弹簧', id: 311},
            {name: '其它', id: 312}
          ]},
        { name: '专用',
          id: 51,
          children: [
            {name: '热处理设备', id: 313},
            {name: '检定设备器具', id: 314},
            {name: '检验设备器具', id: 315},
            {name: '医疗设备器械', id: 316},
            {name: '生活电器', id: 317},
            {name: '园林绿化', id: 318},
            {name: '打包机', id: 319},
            {name: '其它', id: 320}
          ]},
        { name: '特种',
          id: 52,
          children: [
            {name: '锅炉及辅机', id: 321},
            {name: '压力容器', id: 322},
            {name: '起重机械', id: 323},
            {name: '电梯', id: 324},
            {name: '其它', id: 325}
          ]}
      ] },
    { name: '建设工程类',
      id: 4,
      children: [
        { name: '总承包',
          id: 53,
          children: [
            {name: '建筑', id: 326},
            {name: '公路', id: 327},
            {name: '铁路', id: 328},
            {name: '港口与航道', id: 329},
            {name: '水利水电', id: 330},
            {name: '电力', id: 331},
            {name: '矿山', id: 332},
            {name: '冶金', id: 333},
            {name: '石油化工', id: 334},
            {name: '市政公用', id: 335},
            {name: '通信', id: 336},
            {name: '机电', id: 337}
          ]},
        { name: '建筑',
          id: 54,
          children: [
            {name: '土建', id: 338},
            {name: '钢结构', id: 339},
            {name: '电气', id: 340},
            {name: '给排水', id: 341},
            {name: '制热制冷通风', id: 342},
            {name: '井巷', id: 343},
            {name: '炉窑', id: 344},
            {name: '消防', id: 345},
            {name: '防雷', id: 346},
            {name: '其它', id: 347}
          ]},
        { name: '机电',
          id: 55,
          children: [
            {name: '采矿', id: 348},
            {name: '选矿', id: 349},
            {name: '炼焦', id: 350},
            {name: '化工', id: 351},
            {name: '烧结', id: 352},
            {name: '炼铁', id: 353},
            {name: '炼钢', id: 354},
            {name: '轧钢', id: 355},
            {name: '钒业', id: 356},
            {name: '钛业', id: 357},
            {name: '发电', id: 358},
            {name: '输配电', id: 359},
            {name: '燃气', id: 360},
            {name: '氧气', id: 361},
            {name: '供水', id: 362},
            {name: '运输', id: 363},
            {name: '通用', id: 364},
            {name: '其它', id: 365}
          ]},
        { name: '自动化',
          id: 56,
          children: [
            {name: '低压配电', id: 366},
            {name: '高压配电', id: 367},
            {name: '传动控制系统', id: 368},
            {name: '仪器仪表及自动化', id: 369},
            {name: '其它', id: 370}
          ]},
        { name: '信息通信',
          id: 57,
          children: [
            {name: '计算机信息系统及网络', id: 371},
            {name: '软件系统开发', id: 372},
            {name: '通信', id: 373},
            {name: '音视频系统', id: 374},
            {name: '报警及安防系统', id: 375},
            {name: '其它', id: 376}
          ]},
        { name: '安全环保节能',
          id: 58,
          children: [
            {name: '安全', id: 377},
            {name: '环保', id: 378},
            {name: '节能', id: 379},
            {name: '水处理', id: 380},
            {name: '其它', id: 381}
          ]},
        { name: '专项',
          id: 59,
          children: [
            {name: '铁路', id: 382},
            {name: '公路', id: 383},
            {name: '幕墙', id: 384},
            {name: '起重设备', id: 385},
            {name: '电梯', id: 386},
            {name: '压力容器', id: 387},
            {name: '压力管道', id: 388},
            {name: '锅炉', id: 389},
            {name: '装饰装修', id: 390},
            {name: '园林绿化', id: 391},
            {name: '资源综合利用', id: 392},
            {name: '其它', id: 393}
          ]}
      ] },
    { name: '维修工程类',
      id: 5,
      children: [
        { name: '建筑',
          id: 60,
          children: [
            {name: '土建', id: 394},
            {name: '钢结构', id: 395},
            {name: '电气', id: 396},
            {name: '给排水', id: 397},
            {name: '制热制冷通风', id: 398},
            {name: '井巷', id: 399},
            {name: '炉窑', id: 400},
            {name: '消防', id: 401},
            {name: '防雷', id: 402},
            {name: '其它', id: 403}
          ]},
        { name: '机电',
          id: 61,
          children: [
            {name: '采矿', id: 404},
            {name: '选矿', id: 405},
            {name: '炼焦', id: 406},
            {name: '化工', id: 407},
            {name: '烧结', id: 408},
            {name: '炼铁', id: 409},
            {name: '炼钢', id: 410},
            {name: '轧钢', id: 411},
            {name: '钒业', id: 412},
            {name: '钛业', id: 413},
            {name: '发电', id: 414},
            {name: '输配电', id: 415},
            {name: '燃气', id: 416},
            {name: '氧气', id: 417},
            {name: '供水', id: 418},
            {name: '运输', id: 419},
            {name: '通用', id: 420},
            {name: '其它', id: 421}
          ]},
        { name: '自动化',
          id: 62,
          children: [
            {name: '低压配电', id: 422},
            {name: '高压配电', id: 423},
            {name: '传动控制系统', id: 424},
            {name: '仪器仪表及自动化', id: 425},
            {name: '其它', id: 426}
          ]},
        { name: '信息通信',
          id: 63,
          children: [
            {name: '计算机信息系统及网络', id: 427},
            {name: '软件系统开发', id: 428},
            {name: '通信', id: 429},
            {name: '音视频系统', id: 430},
            {name: '报警及安防系统', id: 431},
            {name: '其它', id: 432}
          ]},
        { name: '安全环保节能',
          id: 64,
          children: [
            {name: '安全', id: 433},
            {name: '环保', id: 434},
            {name: '节能', id: 435},
            {name: '水处理', id: 436},
            {name: '其它', id: 437}
          ]},
        { name: '专项',
          id: 65,
          children: [
            {name: '铁路', id: 438},
            {name: '公路', id: 439},
            {name: '幕墙', id: 440},
            {name: '起重设备', id: 441},
            {name: '电梯', id: 442},
            {name: '压力容器', id: 443},
            {name: '压力管道', id: 444},
            {name: '锅炉', id: 445},
            {name: '装饰装修', id: 446},
            {name: '园林绿化', id: 447},
            {name: '资源综合利用', id: 448},
            {name: '其它', id: 449}
          ]}
      ] },
    { name: '服务类',
      id: 6,
      children: [
        { name: '工程服务',
          id: 66,
          children: [
            {name: '咨询', id: 450},
            {name: '勘测', id: 451},
            {name: '设计', id: 452},
            {name: '造价', id: 453},
            {name: '监理', id: 454}
          ]},
        { name: '运输',
          id: 67,
          children: [
            {name: '道路货运', id: 455},
            {name: '道路客运', id: 456},
            {name: '海上运输', id: 457},
            {name: '水路运输', id: 458},
            {name: '铁路运输', id: 459},
            {name: '航空运输', id: 460},
            {name: '多式联运', id: 461},
            {name: '其它', id: 462}
          ]},
        { name: '仓储理货',
          id: 68,
          children: [
            {name: '封闭仓库', id: 463},
            {name: '半封闭仓库', id: 464},
            {name: '货场', id: 465},
            {name: '吊装理货', id: 466},
            {name: '其它', id: 467}
          ]},
        { name: '服务外包',
          id: 69,
          children: [
            {name: '外委加工服务', id: 468},
            {name: '运行包保', id: 469},
            {name: '辅助作业', id: 470},
            {name: '设备修复', id: 471},
            {name: '货运代理', id: 472},
            {name: '劳务派遣', id: 473},
            {name: '住宿餐饮', id: 474},
            {name: '功能承包', id: 475},
            {name: '业务外包（非工程类）', id: 476},
            {name: '其它', id: 477}
          ]},
        { name: '传媒设计制作',
          id: 70,
          children: [
            {name: '平面设计制作', id: 478},
            {name: '立体设计制作', id: 479},
            {name: '图文创意制作', id: 480},
            {name: '影像创意制作', id: 481},
            {name: '印刷', id: 482},
            {name: '其它', id: 483}
          ]},
        { name: '评估认证',
          id: 71,
          children: [
            {name: '评估', id: 484},
            {name: '评审', id: 485},
            {name: '认证', id: 486}
          ]},
        { name: '检测检定',
          id: 72,
          children: [
            {name: '产品检测', id: 487},
            {name: '设备检测', id: 488},
            {name: '环境监测', id: 489},
            {name: '安全监测', id: 490},
            {name: '计量检定', id: 491},
            {name: '其它', id: 492}
          ]},
        { name: '金融保险',
          id: 73,
          children: [
            {name: '融资', id: 493},
            {name: '债券', id: 494},
            {name: '证券', id: 495},
            {name: '保险', id: 496},
            {name: '信托', id: 497},
            {name: '其它', id: 498}
          ]},
        { name: '专项服务',
          id: 74,
          children: [
            {name: '法务', id: 499},
            {name: '财务', id: 500},
            {name: '税务', id: 501},
            {name: '审计', id: 502},
            {name: '咨询', id: 503},
            {name: '规划', id: 504},
            {name: '培训', id: 505},
            {name: '会展', id: 506},
            {name: '翻译', id: 507},
            {name: '通讯', id: 508},
            {name: '租赁', id: 509},
            {name: '拍卖', id: 510},
            {name: '销售', id: 511},
            {name: '处置', id: 512},
            {name: '其它', id: 513}
          ]},
        { name: '其它服务',
          id: 75,
          children: [
            {name: '其它服务', id: 514}
          ]}
      ] }
  ]
}



// WEBPACK FOOTER //
// ./mock/home.js